import React, { useMemo } from 'react';
import { Container } from '@fiverr-private/layout_components';
import { getIsMultiSelect } from '../Dropdown/utils';
import useDropdownContext from '../Dropdown/useDropdownContext';
import { DropdownMenuProps } from './types';
import useMenuContext from './useMenuContext';

const DropdownMenu = ({
  children,
  maxWidth,
  maxHeight,
  height,
  width,
  dataTrackTag = 'dropdown_menu',
  dataTrackValue,
}: DropdownMenuProps) => {
  const { isMultiSelect } = useDropdownContext();
  const { fullWidth, variant } = useMenuContext();
  isMultiSelect.current = useMemo(() => getIsMultiSelect(children), [children]);
  const menuMaxHeight = variant === 'default' ? maxHeight || '248px' : maxHeight;
  const menuMaxWidth = variant === 'default' ? maxWidth || '400px' : maxWidth;

  return (
    <Container
      width={fullWidth ? '100%' : width}
      height={height}
      maxWidth={fullWidth ? '100%' : menuMaxWidth}
      maxHeight={menuMaxHeight}
      overflowX="hidden"
      paddingX={variant === 'default' ? '2' : undefined}
      dataTrackTag={dataTrackTag}
      dataTrackValue={dataTrackValue}
    >
      <Container as="ul" display="flex" direction="column" role="list" gap={isMultiSelect?.current ? '2' : undefined}>
        {children}
      </Container>
    </Container>
  );
};

DropdownMenu.id = 'DropdownMenu';
DropdownMenu.displayName = 'DropdownMenu';

export default DropdownMenu;
